<template>
  <div class="contact-us-page">
    <div class="header-image">
      <img
        :src="require('@/assets/img/VM24_1000.jpg')"
        alt="Subscribe to Porsche Auto Insurance"
      />
    </div>
    <section class="container">
      <h1 class="title ">Stay Connected</h1>
      <div class="columns padding-needed">
        <div class="column is-full">
          <p>
            By signing up to receive emails from
            <span style="white-space: nowrap;">Porsche</span> Auto Insurance,
            you will stay up-to-date on the latest news, coverage expansion,
            policy options, and messages from the insurers who love your Porsche
            as much as you do.
          </p>
          <AvailabilityForm
            isFaq="false"
            @floodlight="floodlightSubscribe"
          ></AvailabilityForm>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { canUseAdvertising, safeGtag } from '@/utils/tracking';
import AvailabilityForm from '@/components/shared/AvailabilityForm.vue';

export default {
  name: 'StayConnected',
  components: {
    AvailabilityForm
  },
  data: () => ({
    subject: '',
    body: '',
    agree: '',
    firstName: '',
    middleInitial: '',
    lastName: '',
    suffix: '',
    email: '',
    telephoneNumber: '',
    url: process.env.VUE_APP_MANDRILL_URL,
    predefinedSubject: process.env.VUE_APP_MANDRILL_EMAIL_SUBJECT,
    fakefromEmailAddress: process.env.VUE_APP_MANDRILL_FAKE_FROM_EMAIL,
    toEmailAddress: process.env.VUE_APP_MANDRILL_TO_EMAIL,
    toName: process.env.VUE_APP_MANDRILL_TO_NAME,
    validationOptions: {
      phoneNumber: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      }
    }
  }),
  methods: {
    ...mapMutations(['toggleLoader']),
    floodlightSubscribe() {
      if (
        process.env.VUE_APP_ENV.toLowerCase() !== 'production' &&
        process.env.VUE_APP_ENV.toLowerCase() !== 'prod'
      ) {
        return;
      } else if (!canUseAdvertising()) {
        return;
      } else {
        // console.log('2025 Floodlight 7 Active');
        // Porsche PAI Stay Connected Form
        let flDiv = document.body.appendChild(document.createElement('div'));
        let GDPR = '${GDPR}';
        let GDPR_CONSENT_755 = '${GDPR_CONSENT_755}';
        flDiv.setAttribute('id', process.env.VUE_APP_FLOODLIGHT_ID);
        flDiv.style.position = 'absolute';
        flDiv.style.top = '0';
        flDiv.style.left = '0';
        flDiv.style.width = '1px';
        flDiv.style.height = '1px';
        flDiv.style.display = 'none';
        flDiv.innerHTML = `<img src="https://ad.doubleclick.net/ddm/activity/src=5368208;type=2025p0;cat=porsc003;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=1?" width="1" height="1" alt=""/>`;
        if (process.env.VUE_APP_GOOGLE_ANALYTICS === 'enable') {
          safeGtag('advertising', 'event', 'conversion', {
            allow_custom_scripts: true,
            send_to: 'DC-5368208/2025p0/porsc003+standard'
          });
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  text-align: center;
}

.contact-us-page {
  .section {
    img {
      object-position: 65% 66% !important;
    }
  }
}

.input__field,
.textarea__field {
  padding: 0.8025rem 1rem !important;
  font-size: 1rem;
  max-height: unset;
}

.container {
  margin-bottom: 4rem;
  padding-bottom: 4rem;
  padding-top: 5rem;
}

.padding-needed {
  padding: 0 2%;
  @media (max-width: 769px) {
    padding: 0;
  }
}
.columns {
  .columns {
    margin-top: 0;
    margin-bottom: 0;
  }
}

.column {
  .column {
    padding-top: 0;
    padding-bottom: 0;
  }
}

label {
  display: inline-block;
}

.subtitle {
  font-family: $family-sans-serif-thin;
  font-size: 20px;
  margin-bottom: 0.25rem;
}

.button-primary {
  float: right;
}
</style>
